import { FC, useContext, useMemo } from 'react';

import { useApolloClient } from '@apollo/client';
import { TextArea, Modal, Button } from '@smartshell/ui-kit';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';

import { useSendShellCommand } from 'hooks';
import { LocalizationContext } from 'localization';

import s from './HostMessageModal.module.scss';
import { FormValues, IHostMessageModalProps } from './ineterfaces';
import { HOST, IHostResponse } from './schema';

export const HostMessageModal: FC<IHostMessageModalProps> = ({
  hostsIds,
  onClose,
}) => {
  const { t } = useContext(LocalizationContext);
  const { sendCommand, sendCommands } = useSendShellCommand(onClose);

  const onSubmit: SubmitHandler<FormValues> = ({ text }) => {
    if (!hostsIds.length) return;
    else if (hostsIds.length === 1) {
      return sendCommand({
        host_id: hostsIds[0],
        action: 'SHOW_MESSAGE',
        param: text,
      });
    } else {
      return sendCommands({
        host_ids: hostsIds,
        action: 'SHOW_MESSAGE',
        param: text,
      });
    }
  };

  const {
    control,
    formState: { isDirty, isSubmitting },
    handleSubmit,
  } = useForm<FormValues>({ mode: 'onChange', defaultValues: { text: '' } });

  // const { data: hostData } = useQuery<IHostResponse>(HOST, {
  //   fetchPolicy: 'cache-only',
  //   variables: { id: hostsIds[0] },
  // });
  // const host = hostData?.hostOverview;

  const apolloClient = useApolloClient();

  const aliases = useMemo<Array<string>>(() => {
    return hostsIds
      .map(
        (hostId) =>
          apolloClient.cache.readQuery<IHostResponse>({
            query: HOST,
            variables: { id: hostId },
          })?.hostOverview.alias ?? ''
      )
      .filter((val) => val);
  }, [hostsIds]);

  // const group = apolloClient.cache.readFragment<{ title: string }>({
  //   id: apolloClient.cache.identify({
  //     __typename: 'HostGroupOverview',
  //     id: host?.group_id,
  //   }),
  //   fragment: gql`
  //     fragment group on HostGroupOverview {
  //       title
  //     }
  //   `,
  // });

  return (
    <Modal onClose={() => onClose(false)}>
      <form className={s.root} onSubmit={handleSubmit(onSubmit)}>
        <span className={s.header}>{t('host.message.title')}</span>
        <div className={s.fields}>
          <span className={s.group}>{aliases.join(', ')}</span>
          <Controller
            render={({ field, fieldState: { error } }) => (
              <TextArea
                {...field}
                title={''}
                variant={'secondary'}
                placeholder={t('host.message.field')}
                error={error?.message}
                limit={70}
                className={s.textarea}
              />
            )}
            name="text"
            control={control}
            rules={{
              required: t('errors.required'),
              minLength: {
                value: 5,
                message: t('errors.minLength', 5),
              },
              maxLength: {
                value: 70,
                message: t('errors.maxLength', 70),
              },
            }}
          />
        </div>
        <Button type="submit" fullWidth disabled={!isDirty || isSubmitting}>
          {t('host.message.submit')}
        </Button>
      </form>
    </Modal>
  );
};
